"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".api-fetch-reload[_ngcontent-%COMP%]{width:100%;height:100%;z-index:10;background-color:#f3ededcf;position:absolute;-webkit-animation:3s ease-in smoothBlock;animation:3s ease-in smoothBlock}@-webkit-keyframes smoothBlock{0%{opacity:0}100%{opacity:1}}"];
exports.styles = styles;
